import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'

const Floor = () => {
  const { t, updateAddress, errors, floor, isApartment, showFloor, showAddressFields } = useAddress()

  if (!showFloor || !showAddressFields || !isApartment) {
    return null
  }

  return (
    <SDFormControl plainLabel error={getError('floor', errors)}>
      <SDInput
        label={t('subscriptionForm:address_module.floor')}
        onBlur={floor => updateAddress({ floor })}
        currentValue={floor}
      />
    </SDFormControl>
  )
}

export default Floor
